export const WarehouseTransferType = {
   tt_regular           	: 0,
   tt_presales           	: 1,
   tt_regular_mobile     	: 5,
   tt_sr_to_sr_load      	: 11,
   tt_sr_to_sr_unload     : 12,
   tt_handover_load      	: 21,
   tt_handover_unload     : 22,
   tt_purchase			      : 30,
   tt_direct			        : 40
 };
 
